"use client";

import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { lessonGrades } from "../utils/paramators";

interface PieChartsProps {
	totalLessonsPerGrades: string[];
}

const COLOR = ["#82ca9d", "#8884d8", "#884a81"];

export default function MonthlyPieCharts(props: PieChartsProps) {
	const gradesData = props.totalLessonsPerGrades.map((time, index) => ({
		name: lessonGrades[index + 1],
		value: Number(time),
		fill: COLOR[index],
	}));

	return (
		<div className="h-96 w-full items-center justify-center px-3 py-6 lg:w-1/2">
			<ResponsiveContainer width="100%" height="100%">
				<PieChart>
					<Pie
						data={gradesData}
						outerRadius={95}
						startAngle={90}
						endAngle={-270}
						fill="#8884d8"
						dataKey="value"
						label
					>
						{gradesData.map((entry, index) => (
							<Cell key={`cell-${index}`} />
						))}
					</Pie>
					<Tooltip />
				</PieChart>
			</ResponsiveContainer>
		</div>
	);
}
